import { TabView } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { VehicleKBA } from '../../../../../domain'
import { TExtends, TKeyBuilder } from '../../../../../infrastructure/internationalisation'
import { VehicleLookupKBA } from '../VehicleLookupKBA'
import { VehicleSelectKBA } from '../VehicleSelectKBA'
import { VehicleTabsConfigKBA } from './types'

export interface VehicleTabsKBAProps {
  t: TFunction
  tKey: TKeyBuilder
  tName: string
  initialTab: number
  config?: VehicleTabsConfigKBA
  value: VehicleKBA | null
  onChange: (value: VehicleKBA | null) => void
}

export const VehicleTabsKBA: FunctionComponent<VehicleTabsKBAProps> = ({
  t,
  tKey,
  tName,
  initialTab,
  config,
  value,
  onChange,
}) => {
  const [tab, setTab] = useState(initialTab)

  const handleChange = useCallback(
    (value: VehicleKBA | null) => {
      onChange(value)
    },
    [onChange],
  )

  const handleEmpty = useCallback(() => setTab(1), [])

  const tabItems = [
    {
      header: t(tKey('tab-headers.lookup')),
      component: () => (
        <VehicleLookupKBA
          config={config}
          value={value}
          onChange={handleChange}
          onEmpty={handleEmpty}
          name={tName}
          tKey={TExtends(tKey, 'lookup')}
        />
      ),
    },
    {
      header: t(tKey('tab-headers.select')),
      component: () => (
        <VehicleSelectKBA
          config={config}
          value={value}
          onChange={handleChange}
          tKey={TExtends(tKey, 'select')}
        />
      ),
    },
  ]

  return (
    <TabView width={1} key={tab} items={tabItems} tabIndex={tab} onTabChange={setTab} />
  )
}
